import useBranchId from "@/shared/hooks/useBranchId";
import { useQueryClient } from "@tanstack/react-query";

const useActiveOrdersSessionsRefetch = () => {
  const queryClient = useQueryClient();
  const branch = useBranchId();
  const queryKey = ["ordersSessions", "active", "order", branch];
  return () =>
    queryClient.refetchQueries({
      queryKey: queryKey,
    });
};

export default useActiveOrdersSessionsRefetch;
